function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z"
});

function SvgFacebookIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJjdXJyZW50Q29sb3IiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTE0IDEzLjVoMi41bDEtNEgxNHYtMmMwLTEuMDMgMC0yIDItMmgxLjVWMi4xNGMtLjMyNi0uMDQzLTEuNTU3LS4xNC0yLjg1Ny0uMTRDMTEuOTI4IDIgMTAgMy42NTcgMTAgNi43djIuOEg3djRoM1YyMmg0di04LjV6Ii8+Cjwvc3ZnPgo=";
export { SvgFacebookIcon as ReactComponent };